import * as React from "react";
import Layout from "../../components/Layout";
import Fund150PromoEnglishImage from "../../img/150-years/jvc-150-fund-ca-promo-final-english.png";
import Fund150PromoTamilImage from "../../img/150-years/jvc-150-fund-ca-promo-final-tamil.png";

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Layout
        pageTitle="150th Anniversary College Fund"
        pageDescription="150th Anniversary Fund for J/Victoria College, Chulipuram, Sri Lanka."
        pageSlug="/150-years-college-fund/"
      >
        <section className="section">
          <div className="container">
            <div className="content">
              <div className="columns">
                <div className="column is-12">
                    <h3 className="has-text-weight-semibold is-size-2">
                      J/Victoria College's 150th Anniversary Fund 2026
                    </h3>
                    <div className="columns is-multiline">
                      <div className="is-parent column is-6">
                        <a
                          href={Fund150PromoTamilImage}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img style={{ borderRadius: "16px" }} src={Fund150PromoTamilImage} alt="150th Anniversary Fund 2026" />
                        </a>
                      </div>
                      <div className="is-parent column is-6">   
                        <a
                          href={Fund150PromoEnglishImage}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img style={{ borderRadius: "16px" }} src={Fund150PromoEnglishImage} alt="150th Anniversary Fund 2026" />
                        </a>
                      </div>
                    </div>
                    <a href="/150-years-college-fund/governance-document">
                      <strong>Fund Governance Document (in Tamil) / நிதி நிர்வாக ஆவணம்</strong>
                    </a>
                  </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}
